<lyceo-ui-menu class="menu" *transloco="let t">
  <lyceo-ui-menu-item
    [link]="['/home']"
    class="home-menu-item"
    data-testid="home-menu-item"
  >
    <fa-icon [icon]="faHouse" />
    {{ t('menu.home') }}
  </lyceo-ui-menu-item>
  @if (personId(); as personId) {
    <lyceo-ui-menu-item [link]="['/pupils', personId, 'information']">
      <fa-icon [icon]="faUser" />
      {{ t('menu.information') }}
    </lyceo-ui-menu-item>
    <lyceo-ui-menu-item [link]="['/pupils', personId, 'plan']">
      <fa-icon [icon]="faCalendarDays" />
      {{ t('menu.planning') }}
    </lyceo-ui-menu-item>
  }
  <lyceo-ui-menu-item
    *ttFeatureFlag="FeatureFlag.FLASHCARDS"
    [link]="['/flashcards']"
  >
    <fa-icon [icon]="faCardsBlank" />
    {{ t('menu.flashcards') }}
  </lyceo-ui-menu-item>
  <lyceo-ui-menu-item data-testid="more-menu-item" (click)="moreMenu()">
    <fa-icon [icon]="faEllipsis" />
    {{ t('menu.more') }}
  </lyceo-ui-menu-item>
  <lyceo-ui-menu-item
    class="logout-menu-item"
    data-testid="logout-menu-item"
    (click)="logout()"
  >
    <fa-icon [icon]="faArrowRightFromBracket" />
    {{ t('menu.logout') }}
  </lyceo-ui-menu-item>
</lyceo-ui-menu>
